import { Language } from '@yleisradio/areena-types';
import NodeCache from 'node-cache';
import { yleHeaderAssetsUrl } from './properties/frontend';

const headerUri = {
  fi: `${yleHeaderAssetsUrl}/areena-inline.html`,
  sv: `${yleHeaderAssetsUrl}/svenska-inline.html`,
};

const cache = new NodeCache({});

const cacheDuration = {
  appData: 60 * 60, // 60 min
};

export const getGlobalHeader = async (language: Language): Promise<string> => {
  let html = cache.get(`globalHeader_${language}`);
  if (!html) {
    const response = await fetch(headerUri[language]);
    html = await response.text();
    cache.set(`globalHeader_${language}`, html, cacheDuration.appData);
  }
  return html as string;
};
